<template>
  <div class="sequence-creator-page-editor">
    <div
      v-if="sequence_clone_ready"
      :class="{
        'sequence-creator-page-editor-main': true,
        'sequence-dirty': document_dirty
      }">

      <div class="topbar">
        <el-button
          @click="onSaveDocument"
          class="px-2"
          type="primary"
          :disabled="!document_dirty">
          {{document_dirty ? 'Save unsaved changes...' : 'All changes saved'}}
        </el-button>

        <!--
        <el-button @click="onPreview" class="px-2" type="secondary" :disabled="true">
          Preview
        </el-button>
        <el-button @click="onExport(false)" class="px-2" type="secondary">
          Export
        </el-button>
        -->

        <!--
        <div class="topbar-view-buttons">
          <a href="#" @click.prevent="onChangeView('table')">Show as table</a> |
          <a href="#" @click.prevent="onChangeView('list')">Show as list</a>
        </div>
        -->
      </div>

      <!-- TOOD: move to component -->
      <div class="sequence-outer-container">
        <div class="sequence-inner-container" v-if="sequence_clone">
          <workflow-sequence-header
            :sequence="sequence"
            :show-connection="draggablesList.length > 0"
            :dirty="document_dirty"
            @save="onSaveDocument"
            @add="onAddItem" />
            <!-- todo: slot header -->
            <!-- :title="sequence.name"
            :description="sequence.description"
            :picture="sequence.picture" -->
          <draggable
            :style="{ minHeight: show_placeholder ? '107px' : '107px' }"
            v-model="draggablesList"
            group="sequence"
            :animation="0"
            draggable=".action-draggable"
            chosenClass="sortable-chosen"
            dragClass="sortable-drag"
            :disabled="false"
            @add="setDocumentDirty">
            <component
              v-for="(item, idx) in draggablesList"
              :key="'x-item-'+item.groupId+'-'+item.id+'-'+idx"
              v-bind:is="item.groupId === 1 ? 'workflow-primitive' : 'workflow-composite'"
              class="action-draggable"
              v-model="draggablesList[ idx ]"
              @input="setDocumentDirty"
              :show-connection="idx !== draggablesList.length - 1"
              @remove="onRemoveItem( idx )"
              @duplicate="onAddItem( $event, idx )">
              <!-- <pre>
                idx: {{idx}}
                data: {{draggablesList[ idx ]}}
              </pre> -->
            </component>

          </draggable>
          <!-- slot="footer" -->
          <workflow-next
            style="margin-top: -107px; padding-bottom: 20px"
            v-show="draggablesList.length === 0 && show_placeholder"
            @add="onAddFirstItem" />
          <!-- todo: slot footer -->
          <!-- todo: hide on drag -->
        </div>
        <pre v-if="SHOW_DEBUG" class="mini-pre m-2" style="overflow: scroll; width: 98%;">{{ draggablesList }}</pre>
        <!-- <pre class="mini-pre m-2" v-if="sequence_clone">{{ sequence_clone.sequenceItemList }}</pre> -->
        <!-- <TestRoutine /> -->
        <!-- <DynamicSequenceConfig
          v-if="sequence.$ready"
          :sequence="sequence"
          :isNew="true" /> -->
      </div>
    </div>
    <div class="sequence-creator-page-editor-main no-content" v-else>
      Loading...
    </div>
    <div class="sequence-creator-page-suggestions">
      <SequenceSuggestions
        @add="onAddItem"
        @first-move="onUpdatePlaceholder( false, $event )"
        @drag-end="onUpdatePlaceholder( true, $event )"
        ref="seqSuggestions" />
    </div>

    <!-- <hr> -->
    <!-- <TestWorkflow /> -->
  </div>
</template>

<script>
import Vue from 'vue'
import Draggable from 'vuedraggable';
import clonedeep from 'lodash.clonedeep'
import util from '@/util'
import { flatten_sequence } from '@/models/sequence/util'
import WorkflowSequenceHeader from '@/components/RoutineCreatorPage/Elements/WorkflowSequenceHeader'
import WorkflowComposite from '@/components/RoutineCreatorPage/Elements/WorkflowComposite'
import WorkflowPrimitive from '@/components/RoutineCreatorPage/Elements/WorkflowPrimitive'
import WorkflowNext from '@/components/RoutineCreatorPage/Elements/WorkflowNext'

// import TestWorkflow from '@/components/RoutineCreatorPage/TestWorkflow'
// import TestRoutine from '@/components/RoutineCreatorPage/TestRoutine'
// import DynamicSequenceConfig from '@/components/RoutineCreatorPage/EditableSequence'
import SequenceSuggestions from '@/components/RoutineCreatorPage/SequenceSuggestions'

import '@/components/RoutineCreatorPage/Style/workflow_without_bootstrap.css'

export default {
  name: "EditorSubpage",
  data: () => ({
    show_placeholder: true,
    sequence: null,
    sequence_clone_ready: false,
    sequence_clone: null,
  }),
  created() {
    // console.log("CREATED");
    // this.sequence_clone = this.sequence.clone();
    this.sequence = this.$models.sequence.subscribeNode( this.$route.params.sequenceId )
    this.sequence_clone_ready = false;
  },
  mounted() {
    // console.log("MOUNTED");
  },
  watch: {
    '$route': {
      handler(to) {
        /* Does not work */
        console.log("ROUTE CHANGE DETECTED");
        return false;
      }
    },
    '$route.params.sequenceId': {
      handler(to) {
        /* Does not work */
        console.log("ROUTE", to);
        this.sequence_clone_ready = false;
      }
    },
    /* Does not work:
    sequence( value ) {
      if ( value.$ready ) {
        this.item_list = this.$models.sequenceAction.with({ sequenceId: this.$route.params.sequenceId }).getList();
      }
    }
    */
    'sequence.$ready': {
      handler(ready) {
        console.log("READY", ready);
        if (ready) {
          setTimeout(() => this.clone(), 50); // TODO: remove 500
        }
      },
      deep: true
    },
  },
  computed: {
    // sequence() {
    //   return this.$models.sequence.subscribeNode( this.$route.params.sequenceId )
    // },
    document_dirty() {
      if ( this.sequence_clone_ready ) {
        return Object.keys(this.sequence_clone.$dirty).length > 0;
      }
      return false
    },
    draggablesList: {
      get() {
        return this.sequence_clone_ready ? this.sequence_clone.sequenceItemList : [];
      },
      set(items) {
        // console.log("Got NEW DRAGLIST: ", items);
        this.sequence_clone.sequenceItemList = items;
        this.setDocumentDirty();
      }
    },
  },
  methods: {
    clone() {
      this.sequence_clone = this.sequence.clone();
      Vue.set(this.sequence_clone.$state, 'sequenceItemList', [])

      /* WORKAROUND */
      this.sequence_clone.$state.sequenceItemList =
        this.sequence.$state.sequenceItemList
        ? clonedeep( this.sequence.$state.sequenceItemList )
        : [];

      // console.log("SEQUENCE IS READY", this.sequence, this.sequence_clone);
      // console.log("DIRTY", JSON.stringify(this.sequence_clone.$dirty));

      /*
      Vue.observable(this.sequence_clone.$dirty)
      this.$watch('sequence_clone.$dirty', (x) => {
      this.$watch(() => this.sequence_clone.$dirty, clone => {
        console.log("Watcher", clone.sequenceItemList);
      })
      */

      Vue.delete(this.sequence_clone.$dirty, 'sequenceItemList');
      this.sequence_clone_ready = true;
    },
    // clone() {
    //   // TODO: also check if data hab been updated
    //   if ( !this.sequence_clone ) {
    //     this.sequence_clone = this.sequence.clone();
    //     // Vue.observable(this.sequence_clone)
    //     Vue.observable(this.sequence_clone.sequenceItemList)
    //     console.log("**** this.sequence_clone ****", this.sequence_clone);
    //   }
    // },
    onAddItem( item, index = null ) {
      console.log("item", item);
      if ( index !== null ) {
        this.sequence_clone.$state.sequenceItemList.splice( index, 0, item )
      } else {
        this.sequence_clone.$state.sequenceItemList.push( item )
      }
      Vue.set(this.sequence_clone.$dirty, 'sequenceItemList', true);

      // // this.clone();
      // console.log("onAddItem", item, this.sequence, this.sequence_clone);
      // // if ( !this.sequence_clone.sequenceItemList ) {
      // //   this.sequence_clone.sequenceItemList = [];
      // //   Vue.observable(this.sequence_clone.sequenceItemList)
      // //   // this.sequence_clone.sequenceItemList = {};
      // // }
      // // TODO: keep ref to original item and allow to "ungroup" later
      // item.actions.forEach( action => {
      //   // let id = this.$models.sequenceAction._get_uid();
      //   // Vue.set(this.sequence_clone.sequenceItemList, id, action )
      //   this.sequence_clone.$state.sequenceItemList.push( action )
      //
      //   // let idx = this.sequence_clone.sequenceItemList.length;
      //   // Vue.set( this.sequence_clone.sequenceItemList, idx, action );
      // })
      // // console.log("sequenceItemList", this.sequence_clone.$state.sequenceItemList);
      // /*
      // item.actions.forEach( action => {
      //   this.item_list._add_child(action)
      // })
      // */

      // TODO: create function in generic model add_child() !!
      // TODO: Create in auto prop when type is list
    },
    onAddFirstItem() {
      this.$refs.seqSuggestions.addItem( 1, 1 );
    },
    onRemoveItem( idx ) {
      this.sequence_clone.$state.sequenceItemList.splice(idx, 1)
      // this.actionList = this.actionList.filter( item => item.id !== id );
    },
    onChangeView( view ) {
      console.log("onChangeView", view);
      alert('NOT IMPLEMENTED')
    },
    setDocumentDirty() {
      /* WORKAROUND: reactivity on sequenceItemList does not work */
      Vue.delete(this.sequence_clone.$dirty, 'sequenceItemList');
      Vue.set(this.sequence_clone.$dirty, 'sequenceItemList', true);
    },
    onSaveDocument() {
      console.log("Saving document...", this.sequence_clone);
      if ( this.sequence_clone.$isValid ) {
        this.sequence_clone.write();
      } else {
        console.warn("Invalid document");
      }
    },
    onPreview() {
      console.log("onPreview - TODO");
    },
    onUpdatePlaceholder(value, evt) {
      this.show_placeholder = value;
    },
    onExport( save_to_file ) {
      let flat_sequence = flatten_sequence( this.sequence_clone.$state.sequenceItemList );
      console.log("flat_sequence", flat_sequence);
      if ( save_to_file ) {
        util.saveJSON( flat_sequence, 'sequence.json' );
      }
    }
  },
  components: {
    // TestWorkflow,
    WorkflowSequenceHeader,
    WorkflowComposite,
    WorkflowPrimitive,
    WorkflowNext,
    // TestRoutine,
    SequenceSuggestions,
    // DynamicSequenceConfig,
    Draggable,
  }
};
</script>

<style>
.sequence-creator-page-editor {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.sequence-creator-page .sortable-ghost {
  min-height: 107px;
  border: 2px dashed black;
  padding: 0;
  margin-bottom: 25px;
  position: relative;
}
.sequence-creator-page .sortable-ghost .el-card__body > * {
  visibility: hidden;
}
/*
.sequence-creator-page .sortable-ghost .el-card {
  visibility: visible;
  border: 2px dashed red !important;
}
.sequence-creator-page .sortable-ghost::after {
  position: absolute;
  background: #d1d5da;
  height: 40px;
  right: 50%;
  bottom: -20px;
  width: 5px;
  margin-right: -2px;
  content: "";
  z-index: 0;
  overflow: visible;;
}
*/
.sequence-creator-page .sequence-creator-page-editor-main {
  flex: auto;
  justify-content: flex-end;
}
.sequence-creator-page .sequence-creator-page-suggestions {
  width: 360px;
  flex: 0 0 360px;
}
.sequence-creator-page .sequence-outer-container {
  margin: 0;
  padding: 4px;
  background-image: url('../../assets/pattern.png');
  box-shadow: inset 0 4px 6px 0 #444d563d;
  overflow-y: scroll;
  height: calc(100vh - 52px);
}
.sequence-creator-page .sequence-dirty .sequence-outer-container {
  border: 4px solid red;
  padding: 0;
}
.sequence-creator-page .sequence-inner-container {
  width: 384px;
  margin: 0 auto;
  margin-top: 1em
}
.sequence-creator-page-editor-main .topbar {
  background-color: white;
  height: 52px;
  padding: 4px;
  padding-top: 6px;
  padding-right: 10px;
  overflow: hidden; /* ?? */
}
.sequence-creator-page-editor-main .topbar .topbar-view-buttons {
  float: right;
  top: 20%;
  position: relative;
}
</style>
